import React from "react";

import styled from "@emotion/styled";

import LinkComponent, { navigate } from "../../../../../shared/LinkComponent";
import Button from "../../../../../shared/NewForms/Button";
import useStepOverviewStore from "../store";

const ErrorWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
    ${({ theme }) => theme.paddings.containerInner.left};
    ${({ theme }) => theme.paddings.containerInner.right};
`;
const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    max-width: 500px;
    padding: 10px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.red.toString()};
    border: ${({ theme }) => theme.colors.red.toString()} 2px solid;
    border-radius: 2px;
`;

const CheckoutIsExpired = () => {
    const [checkoutIsExpired, checkoutIsExpiredErrorMessage] =
        useStepOverviewStore((state) => [
            state.checkoutIsExpired,
            state.checkoutIsExpiredErrorMessage,
        ]);

    const redirect = () => {
        void navigate("/heizoel/#produkte");
    };

    if (checkoutIsExpired) {
        return (
            <ErrorWrapper>
                <ErrorContainer>
                    {checkoutIsExpiredErrorMessage}
                    <Button color="blue" onClick={redirect}>
                        Neu berechnen
                    </Button>
                </ErrorContainer>
            </ErrorWrapper>
        );
    }
    return null;
};

export default CheckoutIsExpired;
